import React from "react";
import { Text, HistorySelector, FrameIcon, Selector } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { HistoryListWrapper, HistoryWrapper, StepText } from "../styles/Styled";

const purchaseDate = d => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const dateFormate = new Date(d.replace(/ /, "T"));
  const parseDate = Date.parse(dateFormate);

  const dateObj = new Date(parseDate);
  const monthIndex = dateObj.getMonth();
  const monthName = monthNames[monthIndex];
  const year = dateObj.getFullYear();
  const day = dateObj.getDate();
  return `${day} ${monthName}, ${year}`;
};

const purchasePrice = item => {
  const currency = item.currency;
  const amount = item.amount;
  return `${currency} ${amount}`;
};

export const History = ({ historylist, isFromSettingsPage, confirmationOptions, onItemSelected, isBottonShowing }) => {
  return (
    <>
      {historylist && (!historylist.length || historylist.length === 0) ? (
        <HistoryWrapper>
          <FrameIcon name="storeLarge" />
          <Text rank="1" text={i18n.get(`pages.settings.history.heading`)} size="xmedium" />
          <Text text={i18n.get(`pages.settings.history.paragraph1`)} type="primary" size="medium" />
          <Selector
            items={confirmationOptions}
            onItemSelected={onItemSelected}
            isFromSettingsPage={isFromSettingsPage}
            size={"xmedium"}
          />
        </HistoryWrapper>
      ) : (
        <HistoryListWrapper>
          <FrameIcon name="history" />
          <Text rank="1" className={"heading"} text={i18n.get(`pages.settings.history.title`)} size="xmedium" />
          <StepText rank="2" text={i18n.get(`pages.settings.history.paragraph2`)} size="xmedium" />
          <HistorySelector
            items={historylist.map(item => ({
              key: `key_${item.id}`,
              date: purchaseDate(item.purchasedDate),
              title: item.assetTitle.length > 35 ? item.assetTitle.slice(0, 35) + " ..." : item.assetTitle,
              description: i18n.get(`pages.settings.history.${item.subscriptionType}`),
              price: purchasePrice(item)
            }))}
            onItemSelected={onItemSelected}
            selectedIndex={null}
            label={i18n.get(`pages.settings.history.bottomLabel`).toLocaleUpperCase()}
            isBottonShowing={isBottonShowing}
          />
        </HistoryListWrapper>
      )}
    </>
  );
};
